import { render } from "./ParticleLogo.vue?vue&type=template&id=2833aa80&scoped=true"
import script from "./ParticleLogo.vue?vue&type=script&lang=js"
export * from "./ParticleLogo.vue?vue&type=script&lang=js"

import "./ParticleLogo.vue?vue&type=style&index=0&id=2833aa80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2833aa80"]])

export default __exports__